import { Stack, styled } from '@mui/material'
import latestBg from './assets/version-latest.svg'
import { transientOptions } from 'styles/TransientOptions'

export const UpdatesWrap = styled(Stack)`
  width: 1200px;
  padding: 96px 0 0;
  margin: 0 auto;
  ${(props) => props.theme.breakpoints.down('md')} {
    width: 100%;
    padding: 64px 16px 0;
  }
`
export const UpdatesPageTitle = styled('h2')`
  font-size: 24px;
  line-height: 24px;
  font-weight: 600;
  color: #fff;
  padding: 24px 0;
  position: fixed;
`
export const UpdatesMain = styled('div')`
  position: relative;
  margin: 100px 0 0;
`
export const UpdatesLeft = styled('div')`
  display: flex;
  gap: 32px;
  width: 322px;
  background-color: rgba(31, 35, 41, 1);
  position: fixed;
  bottom: 40px;
  top: 196px;

  ${(props) => props.theme.breakpoints.down('md')} {
    display: none;
  }
`
export const UpdatesRight = styled('div')`
  flex: 1;
  padding: 16px 0;
  background-color: rgba(31, 35, 41, 1);
  margin-left: 330px;

  ${(props) => props.theme.breakpoints.down('md')} {
    margin-left: 0;
  }
`
export const UpdatesYears = styled('div')`
  width: 108px;
  margin-top: 80px;
  overflow: auto;
`
export const UpdatesYear = styled('div')`
  position: relative;
  height: 76px;
  font-size: 16px;
  line-height: 20px;
  color: #fff;
  font-weight: 600;
  text-align: right;
  padding: 0 40px 0 0;
  cursor: pointer;

  &::before {
    content: '';
    width: 2px;
    height: 100%;
    background-color: rgba(54, 61, 71, 1);
    position: absolute;
    top: 0;
    right: 12px;
  }
`
export const UpdatesYearFirst = styled(UpdatesYear)`
  height: 57px;
  cursor: default;
`
export const UpdatesYearLast = styled(UpdatesYear)`
  cursor: default;
  &::before {
    display: none;
  }
`
export const UpdatesYearsDot = styled('div', transientOptions)<{
  $active?: boolean
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background-color: rgba(23, 26, 30, 1);
  border: 2px solid;
  border-color: ${({ $active }) =>
    $active ? 'rgba(160, 238, 9, 1)' : 'rgba(54, 61, 71, 1)'};
  border-radius: 50%;
  position: absolute;
  top: 0;
  right: 3px;
  box-shadow: ${({ $active }) =>
    $active ? '0 0 0 3px rgba(160, 238, 9, 0.12)' : 'unset'};

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    background-color: ${({ $active }) =>
      $active ? 'rgba(160, 238, 9, 1)' : 'rgba(78, 87, 101, 1)'};
    border-radius: 50%;
  }
`
export const UpdatesYearsDotSmall = styled(UpdatesYearsDot)`
  width: 14px;
  height: 14px;
  right: 6px;
  &::before {
    width: 5px;
    height: 5px;
  }
`
export const UpdatesVersions = styled('div')`
  flex: 1;
  padding: 32px 0 0 0;

  h3 {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 16px;
  }
  overflow: auto;
`
export const UpdatesVersionList = styled('ul')`
  width: 158px;
  padding: 0;
`
export const UpdatesVersionListItem = styled('li', transientOptions)<{
  $active?: boolean
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  height: 70px;
  padding: 0 0 0 16px;

  background-color: ${({ $active }) =>
    $active ? 'rgba(42, 49, 57, 1)' : 'unset'};
  border-left: 2px solid;
  border-color: ${({ $active }) =>
    $active ? 'rgba(160, 238, 9, 1)' : 'transparent'};

  border-radius: 3px;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`
export const UpdatesVersionLatest = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 61px;
  height: 20px;
  text-align: center;
  color: #171a1e;
  font-size: 14px;
  font-weight: 600;
  padding: 0 0 0 8px;
  background: url(${latestBg}) no-repeat;
`
export const UpdatesVersionNumber = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #fff;
  font-size: 14px;
  line-height: 20px;
`
export const UpdatesVersionDate = styled('div')`
  color: #fff;
  font-size: 16px;
  font-weight: 700;
`

export const UpdatesRightTitle = styled('div')`
  padding: 16px 32px;
  color: #fff;
  font-size: 28px;
  font-weight: 600;

  ${(props) => props.theme.breakpoints.down('md')} {
    padding: 16px;
  }
`
export const UpdatesArticle = styled('div')`
  padding: 32px;
  border-bottom: 1px solid #2e363b;

  ${(props) => props.theme.breakpoints.down('md')} {
    padding: 32px 16px;
  }
`
export const UpdatesArticleTop = styled('div')`
  display: flex;
  align-items: center;
  padding-bottom: 8px;
`
export const UpdatesArticleVersion = styled('div')`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 104px;
  height: 34px;
  background: #a0ee09;
  color: #171a1e;
  font-size: 14px;
  font-weight: 700;
  border-radius: 17px;
`
export const UpdatesArticleDate = styled('div')`
  display: inline-flex;
  align-items: center;
  height: 34px;
  gap: 8px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  padding: 0 8px;
`
export const UpdatesArticleTitle = styled('div')`
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  padding: 16px 0 0;
`
export const UpdatesArticleContent = styled('ul')`
  color: #95a4ad;
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
  padding: 0 0 0 16px;

  list-style: decimal;

  li {
    padding: 8px 0;
  }
`
